const BaseService = require('./BaseService');
const ApiUrls = require('../helpers/ApiUrls');
const AppSettings = require('../helpers/AppSettings');

class CheckoutService extends BaseService {

    _checkout(payload) {
        return this.api.post(ApiUrls.checkout(), payload);
    }

    async _acheckout(payload, failurecb) {
        try {
            // console.log('base url', AppSettings.baseApiUrl)

            const response = await new Promise(resolve => {
                const res = fetch(`${AppSettings.baseApiUrl}/${ApiUrls.checkout()}`, {
                    method: "POST",
                    body: payload ? JSON.stringify(payload) : "",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Chaipay-Client-Key":AppSettings.secretKey,
                        "Authorization": "Bearer "+AppSettings.jwtToken,
                    },
                })
                resolve(res)
            });

            const responseJson = await response.json();
            return responseJson;
        } catch (error) {
            throw error;
        }
    }

    async _checkoutFlow(payload, onFailure, onBeforeRedirect) {
        payload["chaipay_key"] = AppSettings.secretKey;
        payload["source"] = "checkout";
        var paymentLinkRef = ""
        try {
            // Call await paymentLink api
            const response = await this._acheckout(payload, onFailure);
            // console.log("payment link creation api call response", response)
            paymentLinkRef = response["payment_link_ref"]
            if(payload["override_auto_redirect"]){
                if (onBeforeRedirect) {
                    onBeforeRedirect(response);
                }
                return response
            }
            if (onBeforeRedirect) {
                onBeforeRedirect(response);
            }
        } catch (error) {
            throw error;
        }
        var queryParams = "";
        queryParams += "ref=" + paymentLinkRef

        const checkoutURL = AppSettings.checkoutURL;
        var redirectURL = checkoutURL + "?" + queryParams;

        // console.log("redirect url", redirectURL);

        if (payload["is_checkout_embed"] && window.screen.width > 768) {
            document.getElementById("portone-container").style.display = "block";
            document.getElementById('portone-checkout-frame').src = redirectURL;
        }else{
            window.location.href = redirectURL;
        }
    }

    checkout(payload, onFailure, onBeforeRedirect) {
        this._checkoutFlow(payload, onFailure, onBeforeRedirect);
    }


    getCheckoutHistory(paymentLinkId) {
        return this.api.get(ApiUrls.checkoutHistory(paymentLinkId));
    }


    /**
     * Browser-compatible AES-GCM encryption for redirect URL.
     * @param {Object} params - Order details and config.
     * @returns {Promise<string>} Encrypted redirect URL params or full URL.
     */
    async getNtucEncryptedRedirectUrl({
        ClientOrderID,
        OrderAmount,
        OrderCurrency,
        IsOneTimePayment,
        IsRecurringPayment,
        ClientReturnUrl,
        encryptionKey = "H+MbQeThWmZq4t7w!z%C*F)J@NcRfUjX",
        baseRedirectUrl = ""
    }) {
        const plainData =
            `ClientOrderID=${ClientOrderID}` +
            `&OrderAmount=${OrderAmount}` +
            `&OrderCurrency=${OrderCurrency}` +
            `&IsOneTimePayment=${IsOneTimePayment}` +
            `&IsRecurringPayment=${IsRecurringPayment}` +
            `&ClientReturnUrl=${encodeURIComponent(ClientReturnUrl)}`;

        // Convert key and data to ArrayBuffer
        function strToUint8Array(str) {
            return new TextEncoder().encode(str);
        }
        const keyBytes = strToUint8Array(encryptionKey);
        const dataBytes = strToUint8Array(plainData);

        // Generate 12-byte IV
        const iv = window.crypto.getRandomValues(new Uint8Array(12));

        // Import key
        const cryptoKey = await window.crypto.subtle.importKey(
            'raw',
            keyBytes,
            { name: 'AES-GCM' },
            false,
            ['encrypt']
        );

        // Encrypt
        const encryptedBuffer = await window.crypto.subtle.encrypt(
            { name: 'AES-GCM', iv },
            cryptoKey,
            dataBytes
        );
        const encrypted = new Uint8Array(encryptedBuffer);

        // Split ciphertext and tag
        const tagLength = 16; // 128 bits
        const ciphertext = encrypted.slice(0, encrypted.length - tagLength);
        const tag = encrypted.slice(encrypted.length - tagLength);

        // Helper for base64
        function arrToBase64(arr) {
            return btoa(String.fromCharCode.apply(null, arr));
        }

        const encData = arrToBase64(ciphertext);
        const encTag = arrToBase64(tag);
        const encIV = arrToBase64(iv);

        const params = `Data=${encodeURIComponent(encData)}&tag=${encodeURIComponent(encTag)}&IV=${encodeURIComponent(encIV)}`;
        if (baseRedirectUrl) {
            return `${baseRedirectUrl}?${params}`;
        }
        return params;
    }
}

module.exports = CheckoutService;